export const captionPresets: Record<string, string[]> = {
  seducao: [
    'Me chama no inbox... 😏',
    'To com saudade de voce 💋',
    'Vem ver o que te espera...',
    'Sera que voce aguenta? 🔥',
    'Hoje to assim... pensando em voce 💭',
    'Quem quer minha atencao? 😈',
    'Voce nao vai resistir... 💋',
    'Saudade bate forte ne? Vem 💕',
    'To aceitando convites... sera? 😏',
    'Olha o que preparei pra voce...',
    'Queria tanto te ver agora... 🥰',
    'Vem que hoje eu to carente 💗',
    'Quem me da atencao? 💋',
    'Seu like nao e suficiente... quero mais 😈',
    'Aparece aqui no meu inbox vai... 💌',
  ],
  casual: [
    'Bom dia! Como esta seu dia? ☀️',
    'Boa tarde, meu amor 💕',
    'Boa noite! Descanse bem 🌙',
    'Curtindo o dia por aqui 😊',
    'Mais um dia abençoado! 🙏',
    'Como voces estao? Contem pra mim!',
    'Passando pra dar um oi! 👋',
    'Hoje o dia ta lindo ne? ☀️',
    'Quem mais ta curtindo o dia?',
    'Sextou! Bora aproveitar 🎉',
    'Momento relax por aqui... ☕',
    'Dia produtivo por aqui! E voces?',
    'Aproveitando cada momento 💛',
    'Vibe boa pra hoje! ✨',
    'Fala galera! Tudo bem com voces? 😄',
  ],
  religioso: [
    'Deus abencoe seu dia! 🙏',
    'Gratidao por mais um dia! ✨',
    'O Senhor e meu pastor, nada me faltara 🙏',
    'Confie no plano de Deus para sua vida ✝️',
    'Deus e fiel, sempre! 🕊️',
    'Entregue nas maos de Deus 🙏',
    'Fe acima de tudo! ✨',
    'Deus tem algo lindo preparado pra voce!',
    'Oracao e o melhor remedio 🙏',
    'Deixa Deus agir na sua vida ✝️',
    'Tudo no tempo de Deus 🕊️',
    'Que Deus proteja sua familia! 🙏',
    'A graca de Deus e suficiente ✨',
    'Obrigado Senhor por tudo! 🙏',
    'Deus nunca abandona seus filhos ✝️',
  ],
  motivacional: [
    'Voce e mais forte do que imagina! 💪',
    'Hoje e dia de vencer!',
    'Nao desista, voce esta quase la! 🚀',
    'Acredite no seu potencial ✨',
    'Levanta e vai! O mundo e seu 🌍',
    'Cada dia e uma nova chance de brilhar ⭐',
    'Foco, forca e fe! 💪',
    'Seu sonho ta mais perto do que voce pensa!',
    'Nao deixe ninguem apagar sua luz ✨',
    'Voce nasceu pra vencer! 🏆',
    'O sucesso e construido dia a dia 📈',
    'Transforme seus sonhos em metas! 🎯',
    'Quem acredita sempre alcanca! 💫',
    'Sua hora vai chegar, continue firme! 💪',
    'Impossivel e so uma palavra, va e faca! 🔥',
  ],
}

export const captionTones = [
  { value: 'seducao', label: 'Seducao' },
  { value: 'casual', label: 'Casual' },
  { value: 'religioso', label: 'Religioso' },
  { value: 'motivacional', label: 'Motivacional' },
  { value: 'personalizado', label: 'Personalizado' },
] as const
